import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Badge, BadgeList } from './Badge';

const pl = {
  tag: 'przepisy',
  active: 'aktywny',
  disabled: 'wyłączony',
  missing: 'brak kcal',
  tags: [
    'praca',
    'dom',
    'pomysły',
    'czytanie',
    'podróże',
    'kod',
    'baza',
    'notatki',
    'spotkanie',
    'szkic',
    'przegląd',
    'archiwum',
  ],
};

const sample: Dictionary<typeof pl> = {
  pl,
  en: {
    tag: 'recipes',
    active: 'active',
    disabled: 'disabled',
    missing: 'no kcal',
    tags: [
      'work',
      'home',
      'ideas',
      'reading',
      'travel',
      'code',
      'db',
      'notes',
      'meeting',
      'draft',
      'review',
      'archive',
    ],
  },
};

export default {
  kind: 'component',
  title: { pl: 'Odznaka', en: 'Badge' },
  description: {
    pl: 'Pigułka. `neutral` dla tagów, `success`/`danger` dla statusu, `warning` dla czegoś, co trzeba uzupełnić. `BadgeList` zawija odznaki w tyle linii, ile potrzeba.',
    en: 'A pill. `neutral` for tags, `success`/`danger` for a status, `warning` for something the user should fill in. `BadgeList` wraps badges onto as many lines as they need.',
  },
  variants: [
    {
      name: { pl: 'Tony', en: 'Tones' },
      render: (locale) => (
        <BadgeList>
          <Badge tone="neutral">{sample[locale].tag}</Badge>
          <Badge tone="success">{sample[locale].active}</Badge>
          <Badge tone="danger">{sample[locale].disabled}</Badge>
          <Badge tone="warning">{sample[locale].missing}</Badge>
        </BadgeList>
      ),
    },
    {
      name: { pl: 'Długa lista', en: 'Long list' },
      render: (locale) => (
        <BadgeList>
          {sample[locale].tags.map((tag) => (
            <Badge key={tag} tone="neutral">
              {tag}
            </Badge>
          ))}
        </BadgeList>
      ),
    },
  ],
} satisfies Story;
